import React, { useEffect, useRef, useState } from "react";
import commonStyles from "../../Shared/commonStyles.module.css";
import CTAStyles from "../../Shared/CallToAction/CallToAction.module.css";
import styles from "./Teaser.module.css";
import { Link } from "react-router-dom";
import { FaTree } from "react-icons/fa";

function Teaser() {

const iconRef = useRef(null);
  const [hasWiggled, setHasWiggled] = useState(false);

useEffect(() => {
  const node = iconRef.current;
  if (!node) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry) return;

      setHasWiggled(
        entry.isIntersecting && entry.intersectionRatio >= 0.5
      );
    },
    { threshold: 0.5 }
  );

  observer.observe(node);

  return () => observer.disconnect();
}, []);

  return (
    <section className={`${commonStyles.section}`}>
      <div className={commonStyles.container}>
        <div className={styles.final}>
          <div className={styles.teaserImageContainer}>
            <h2>Are you ready for Christmas?</h2>
             <div
            ref={iconRef}
            className={`${styles.treeWrap} ${hasWiggled ? styles.wiggle : ""}`}
          >
            <FaTree className={styles.treeIcon} />
          </div>
          </div>
          < p className={styles.teaserText}>
            We can help you plan your Christmas gifts. We are hosting a relaxed
            2 hour session to help you think and plan before starting your
            Christmas shopping.
          </p>
          <div className={commonStyles.heroCtas}>
            <Link
              to="/GetChristmasSorted"
              className={`${commonStyles.btn}  ${styles.ChristmasButton}`}
            >
              Get Christmas Sorted
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Teaser;
